var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonQuickSight32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-QuickSight_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-QuickSight_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Analytics",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.9993329,13 C32.9993329,12.449 32.551034,12 31.9986658,12 C31.4462975,12 30.9979987,12.449 30.9979987,13 C30.9979987,13.551 31.4462975,14 31.9986658,14 C32.551034,14 32.9993329,13.551 32.9993329,13 L32.9993329,13 Z M21.5096731,24 C21.5096731,23.448 21.0603736,23 20.509006,23 C19.9566378,23 19.5083389,23.448 19.5083389,24 C19.5083389,24.551 19.9566378,25 20.509006,25 C21.0603736,25 21.5096731,24.551 21.5096731,24 L21.5096731,24 Z M20.509006,17 C21.0603736,17 21.5096731,16.551 21.5096731,16 C21.5096731,15.448 21.0603736,15 20.509006,15 C19.9566378,15 19.5083389,15.448 19.5083389,16 C19.5083389,16.551 19.9566378,17 20.509006,17 L20.509006,17 Z M10.0020013,27 C10.0020013,26.448 9.5527018,26 9.00133422,26 C8.44896598,26 8.00066711,26.448 8.00066711,27 C8.00066711,27.551 8.44896598,28 9.00133422,28 C9.5527018,28 10.0020013,27.551 10.0020013,27 L10.0020013,27 Z M34,13 C34,14.103 33.1024016,15 31.9986658,15 C31.6234156,15 31.2751835,14.89 30.9749833,14.709 L22.0490327,22.738 C22.3322215,23.083 22.5103402,23.519 22.5103402,24 C22.5103402,25.103 21.6117412,26 20.509006,26 C19.4052702,26 18.5076718,25.103 18.5076718,24 C18.5076718,23.07 19.1470981,22.294 20.0086724,22.071 L20.0086724,17.928 C19.7074716,17.85 19.4362909,17.704 19.2081388,17.507 L10.718479,25.99 C10.8945964,26.288 11.0026684,26.63 11.0026684,27 C11.0026684,28.103 10.1040694,29 9.00133422,29 C7.8975984,29 7,28.103 7,27 C7,25.896 7.8975984,25 9.00133422,25 C9.37158105,25 9.71280854,25.107 10.0110073,25.283 L18.6317545,16.669 C18.5557038,16.458 18.5076718,16.235 18.5076718,16 C18.5076718,14.896 19.4052702,14 20.509006,14 C21.6117412,14 22.5103402,14.896 22.5103402,16 C22.5103402,16.929 21.8699133,17.705 21.0093396,17.928 L21.0093396,22.071 C21.0813876,22.089 21.1514343,22.11 21.2204803,22.136 L30.272515,13.995 C30.1024016,13.701 29.9973316,13.364 29.9973316,13 C29.9973316,11.897 30.89493,11 31.9986658,11 C33.1024016,11 34,11.897 34,13 L34,13 Z M9.00133422,9 L32.0166778,9 L32.0166778,10 L33.0173449,10 L33.0173449,8.5 C33.0173449,8.223 32.7931955,8 32.5170113,8 L8.50100067,8 C8.22381588,8 8.00066711,8.223 8.00066711,8.5 L8.00066711,24 L9.00133422,24 L9.00133422,9 Z M32.0166778,16 L33.0173449,16 L33.0173449,32.5 C33.0173449,32.776 32.7931955,33 32.5170113,33 L8.50100067,33 C8.22381588,33 8.00066711,32.776 8.00066711,32.5 L8.00066711,30 L9.00133422,30 L9.00133422,32 L32.0166778,32 L32.0166778,16 Z",
    id: "Amazon-QuickSight-Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonQuickSight32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-QuickSight_32.818d5cedc263deff9e7c080b2d1c48cb.svg";
export { ForwardRef as ReactComponent };